import { createRoute, redirect, isRedirect } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import {
  AUTH_TOKEN_KEY,
  AUTH_HEADER_SCHEME,
  OTP_EMAIL_KEY,
} from '@/shared/constants/auth'
import { getSecureItem, removeSecureItem } from '@/shared/lib/storage'
import { authClient } from '@/shared/lib/betterAuth/auth-client'
import { VerifyCodePage } from './page.verify-code'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.VERIFY_CODE,
  validateSearch: (search: Record<string, string>) => ({
    email: search.email || undefined,
    redirect: search.redirect || undefined,
  }),
  beforeLoad: async () => {
    const token = await getSecureItem(AUTH_TOKEN_KEY)
    if (token) {
      try {
        const { data } = await authClient.getSession({
          fetchOptions: {
            headers: { Authorization: `${AUTH_HEADER_SCHEME} ${token}` },
          },
        })
        if (data) throw redirect({ to: ROUTES.HOME })
        await removeSecureItem(AUTH_TOKEN_KEY)
      } catch (error) {
        if (isRedirect(error)) throw error
        await removeSecureItem(AUTH_TOKEN_KEY)
      }
    }
    const email = sessionStorage.getItem(OTP_EMAIL_KEY)
    if (!email)
      throw redirect({
        to: ROUTES.LOGIN,
        search: { email: undefined, redirect: undefined, token: undefined },
      })
  },
  component: VerifyCodePage,
})
